import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ExpensePickingListState} from "@/interfaces/state";
import store from "@/store"
import {IdMapper} from "@/interfaces/state/base";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {PaginationMeta} from "@/interfaces/common";
import union from "lodash/union";
import {ExpensePickingListParams} from "@/modules/receiptsexpenses/expensepickinglist/params";
import {
    confirmExpenseCustomerPickingList,
    confirmExpensePickingList, deleteExpensePickingList,
    listExpensePickingList
} from "@/modules/receiptsexpenses/expensepickinglist/services";

@Module({ dynamic: true, name: "expensePickingListStore", store })
class ExpensePickingListModule extends VuexModule implements ExpensePickingListState {
    data: IdMapper<ReceiptExpensePickingList> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ExpensePickingListParams = new ExpensePickingListParams();

    @Mutation
    private MAP_EXPENSE_PICKING_LIST(payload: any) {
        const idMapper = {} as any;
        this.meta = payload.meta;
        this.ids = payload.datas?.map((data: ReceiptExpensePickingList, index: number) => {
            idMapper[data.id] = {...data, stt: index + 1};
            return data.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_EXPENSE_PICKING_LIST(payload: ReceiptExpensePickingList) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private DELETE_EXPENSE_PICKING_LIST(payload: ReceiptExpensePickingList) {
        this.ids = this.ids.filter((id: number) => payload.id !== id);
        delete this.data[payload.id];
    }

    @Mutation
    private DELETE_EXPENSE_PICKING_LIST_ID(idPayload: number) {
        this.ids = this.ids.filter((id: number) => idPayload !== id);
        delete this.data[idPayload];
    }

    @Mutation
    private UPDATE_EXPENSE_PICKING_LIST_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private SET_DEBTS_POST_OFFICE_INTO_EXPENSE_PICKING_LIST({ id, debts }) {
        if (this.data[id])
            this.data[id] = { ...this.data[id], debtPostOffices: debts }
    }

    @Mutation
    private SET_DEBTS_CUSTOMER_INTO_EXPENSE_PICKING_LIST({ id, debts }) {
        if (this.data[id])
            this.data[id] = { ...this.data[id], debtCustomers: debts }
    }

    @Action({ rawError: true })
    public async listExpensePickingList(params: ExpensePickingListParams) {
        const { data } = await listExpensePickingList(params);
        this.MAP_EXPENSE_PICKING_LIST(data);
    }

    @Action({ rawError: true })
    public updateExpensePickingListParams(payload: any) {
        this.UPDATE_EXPENSE_PICKING_LIST_PARAMS(payload);
    }

    @Action({ rawError: true })
    public setDebtsPostOfficeIntoExpensePickingList({ id, debts }) {
        this.SET_DEBTS_POST_OFFICE_INTO_EXPENSE_PICKING_LIST({ id, debts });
    }

    @Action({ rawError: true })
    public setDebtsCustomerIntoExpensePickingList({ id, debts }) {
        this.SET_DEBTS_CUSTOMER_INTO_EXPENSE_PICKING_LIST({ id, debts });
    }

    @Action({ rawError: true })
    public setExpensePickingList(payload: any) {
        this.SET_EXPENSE_PICKING_LIST(payload);
    }

    @Action({ rawError: true })
    public async confirmPostOfficeExpensePickingList(id: number) {
        const { data } = await confirmExpensePickingList(id);
        this.SET_EXPENSE_PICKING_LIST(data.data);
    }

    @Action({ rawError: true })
    public async confirmCustomerExpensePickingList(id: number) {
        const { data } = await confirmExpenseCustomerPickingList(id);
        this.SET_EXPENSE_PICKING_LIST(data.data);
    }

    @Action({ rawError: true })
    public async deleteExpensePickingListId(id: number) {
        await deleteExpensePickingList(id);
        this.DELETE_EXPENSE_PICKING_LIST_ID(id);
    }
}

export const ExpensePickingListStore = getModule(ExpensePickingListModule);